import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { getJdiOSFile } from '@/util/index';
import PoPopup from '@/components/Popopup/PoPopup';

const Mark: React.FC<any> = ({ orderDetails }) => {
  const [poPopupVisible, setPoPopupVisible] = useState(false);
  const [orderNo, setOrderNo] = useState('');
  const [thirdOrderId, setThirdOrderId] = useState('');

  useEffect(() => {
    setThirdOrderId(orderRes?.thirdOrderId);
  }, [orderDetails?.orderRes]);

  const orderRes = orderDetails?.orderRes;
  console.log('orderRes---', orderRes);
  const remarks = orderRes?.orderExtInfo ? JSON.parse(orderRes?.orderExtInfo) : {};
  remarks?.settleInfo &&
    remarks?.settleInfo.unshift({
      id: -1,
      category: TLT('客户采购单号'),
      value: thirdOrderId || '',
    });
  return (
    <div className={styles.remarksContent}>
      <div className={styles.customerRemarkSection}>
        <h3 className={styles.sectionTitle}>{TLT(`备注`)}</h3>
        <div className={styles.customerRemarkDetails}>
          {remarks?.settleInfo &&
            remarks?.settleInfo.map((item, idx) => {
              return (
                <div className={styles.remarkRow} key={idx}>
                  <span className={styles.remarkLabel}>{item.category}</span>
                  {
                    item.id === -1 && !item.value ? (
                      <span className={`${styles.remarkValue} underText`} onClick={() => {
                        setOrderNo(orderRes?.orderNo)
                        setPoPopupVisible(true)
                      }}>
                        {TLT(`添加`)}
                          <img
                            className={styles.arrowIcon}
                            src={getJdiOSFile('mubla1/198040366064903939.png')}
                            alt="Arrow icon"
                          />
                      </span>
                    ) : (
                      <span className={styles.remarkValue}>{item.value || '-'}</span>
                    )
                  }
                </div>
              );
            })}
        </div>
      </div>
      {orderRes?.remark && (
        <div className={styles.orderRemarkSection}>
          <h3 className={styles.sectionTitle}>{TLT(`订单备注`)}</h3>
          <p className={styles.orderRemarkText}>{orderRes?.remark ?? ''}</p>
        </div>
      )}

      <PoPopup
        visible={poPopupVisible}
        onCancel={() => setPoPopupVisible(false)}
        orderId={orderNo}
        onConfirm={(id: string) => {
          setThirdOrderId(id)
        }}
      />
    </div>
  );
};
export default Mark;
